module.exports = __webpack_public_path__ + "img/skill-plus.dd485e92.svg";